const baseURL = "https://upd.geezdata.com/api";
const reportURL = "https://task.shopspade.com/api";
const omsURL = "https://oms.geezdata.com/oms_api";
const shopURL = "https://shop.shopspade.com/api";

export { baseURL, reportURL, omsURL, shopURL }
